function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

const commonBackendUrl = trimTrailingSlash(
  import.meta.env.VITE_COMMON_BACKEND_URL ?? 'http://localhost:3001'
);

export const env = {
  appEnv: import.meta.env.VITE_APP_ENV ?? 'local',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',

  commonBackendUrl,

  educate: {
    bootstrapUrl:
      import.meta.env.VITE_EDUCATE_BOOTSTRAP_API_URL ?? `${commonBackendUrl}/educate/bootstrap`,
    storylineUrl:
      import.meta.env.VITE_EDUCATE_STORYLINE_API_URL ??
      `${commonBackendUrl}/educate/get-storyline-data`,
    progressUrl:
      import.meta.env.VITE_EDUCATE_PROGRESS_API_URL ?? `${commonBackendUrl}/educate/progress`,
    resetUrl: import.meta.env.VITE_EDUCATE_RESET_API_URL ?? `${commonBackendUrl}/educate/reset`,
    completeUrl:
      import.meta.env.VITE_EDUCATE_COMPLETE_API_URL ?? `${commonBackendUrl}/educate/complete`,
    markStartedUrl:
      import.meta.env.VITE_MARK_GAME_STARTED_API_URL ?? `${commonBackendUrl}/game/markGameStarted`,
    markCompletedUrl:
      import.meta.env.VITE_MARK_GAME_COMPLETED_API_URL ??
      `${commonBackendUrl}/game/markGameCompleted`
  },

  loginUrl: import.meta.env.VITE_LOGIN_API,
  logoutUrl: import.meta.env.VITE_LOGOUT_API
} as const;
